module.exports = __webpack_public_path__ + "static/media/logo114.95726c74.png";